import { Auditable, FormSelect, QueryParams, SortParams } from "../..";

export interface FormSelectCategory extends Auditable {
    name: string;
    tenantId: number;

    formSelects?: FormSelect[];
}

export const DefaultFormSelectCategoryQueryParams: QueryParams = {
    name: "",
};

export const DefaultFormSelectCategorySortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
